<template>
  <div>
    <div
      :class="[
        'isButton',
        $style.wrapper
      ]"
      @click="handleLanguageMenuOpen"
    >
      <span
        :class="[
          'isButton',
          $style.currentLanguage
        ]"
      >
        {{ currentLanguage }}
      </span>
      <font-awesome-icon
        icon="angle-down"
        size="sm"
      />
    </div>

    <transition name="slide-top">
      <div
        v-if="isLanguageSelectOpen"
        v-click-outside="handleOutsideClick"
        :class="$style.languageSwitcher"
        :style="languageMenuStyle"
      >
        <BaseButton
          v-for="lang in supportedLanguages"
          :key="lang"
          variant="gray"
          alignment="left"
          size="xl"
          is-full-width
          @click="changeLanguage(lang)"
        >
          {{ $t(`languages.full.${lang}`) }}
        </BaseButton>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Trans } from '@/plugins/Translations'
import BaseButton from '@/components/Atoms/BaseButton'

export default {
  components: { BaseButton },
  directives: {
    'click-outside': {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) {
            warn += `Found in component '${compName}'`
          }

          console.warn(warn)
        }
        setTimeout(() => {
          // Define Handler and cache it on the element
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler
          // add Event Listeners
          document.addEventListener('click', handler)
        }, 350)
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      },
    },
  },
  data() {
    return {
      isLanguageSelectOpen: false,
      languageMenuStyle: {
        top: `40px`,
      },
    }
  },
  computed: {
    supportedLanguages() {
      return Trans.supportedLanguages
    },
    currentLanguage() {
      return Trans.currentLanguage
    },
  },
  methods: {
    ...mapActions({
      saveLanguageChange: 'profile/changeLanguage/changeLanguage',
    }),
    changeLanguage(lang) {
      const to = this.$router.resolve({ params: { lang } })
      this.isLanguageSelectOpen = false
      this.$emit('onLanguageChange', { locale: lang })
      this.saveLanguageChange({ lang })
      return Trans.changeLanguage(lang).then(() => {
        this.$router.push(to.location)
      })
    },
    handleLanguageMenuOpen() {
      const offset = document.getElementById('navbar').offsetHeight + document.getElementById('navbar').offsetTop
      this.languageMenuStyle = {
        top: `${offset}px`,
      }
      this.isLanguageSelectOpen = true
    },
    handleOutsideClick() {
      if (this.isLanguageSelectOpen) {
        this.isLanguageSelectOpen = false
      }
    },
    isCurrentLanguage(lang) {
      return lang === this.currentLanguage
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";

  .wrapper {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: .5rem;
  }

  .currentLanguage {
    font-size: $font-size-small;
    text-transform: uppercase;
    padding-right: .25rem;
  }

  .languageSwitcher {
    position: fixed;
    left: 0;
    width: 100vw;
    z-index: 5;

    background-color: $color-white;
  }
</style>
